/* Version: 3.5.137 */
'use client';
import { ButtonDownIcon } from '@manulife/mux-cds-icons';
import styled from 'styled-components';
import { FocusOutline } from '../../mixins/index.js';
import { rem } from '../../utils/functions.js';
import { DEFAULT_INPUT_WIDTH } from './constants.js';
import { typography } from '../../typography/typography.js';

// NOTE: InputWrapper and IconWrapper need to be declared first, to avoid ReferenceError issues in transpiled code
// https://github.com/manulife-innersource/mux-core/issues/2840
var InputWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__InputWrapper",
  componentId: "sc-1v8eybg-0"
})(["--error-bg:", ";display:flex;align-items:center;justify-content:space-between;background:", ";border-radius:0;border:", ";box-sizing:border-box;color:", ";font-family:", ";font-size:", ";line-height:", ";outline:2px solid transparent;outline-offset:0;overflow:hidden;position:relative;text-align:left;width:100%;&:disabled,&[data-disabled='true']{background:", ";border-color:", ";color:", ";cursor:not-allowed;}&:not(:disabled,[data-disabled='true']){&[aria-invalid='true'],&[data-invalid='true']{background:var(--error-bg);border-color:", ";outline:", ";}&:focus,&:focus-within,&[data-focused='true']{border-color:", ";", ";}&:focus-visible,&[data-focusvisible='true'],&:has(:focus-visible){", ";}&:hover:not( :focus-within,[data-focused='true'],[aria-invalid='true'],[data-invalid='true'] ){border-color:", ";}}&[data-variant='basic_line']{--error-bg:", ";background:transparent;border-left:1px solid transparent;border-right:1px solid transparent;border-top:1px solid transparent;&:disabled,&[data-disabled='true']{background:transparent;}&:not(:disabled,[data-disabled='true']){&[aria-invalid='true'],&[data-invalid='true']{border-color:transparent;border-bottom:", ";box-shadow:", ";outline:none;}&:focus,&:focus-within,&[data-focused='true']{border-color:transparent;border-bottom:", ";box-shadow:", ";", ";}&:focus-visible,&[data-focusvisible='true']{", ";}&:hover:not( :focus-within,[data-focused='true'],[aria-invalid='true'],[data-invalid='true'] ){border-left:1px solid transparent;border-right:1px solid transparent;border-top:1px solid transparent;border-bottom:", ";}}}&[data-variant='basic_line_dashed']{--error-bg:", ";--underline-color:", ";background:transparent;border-color:transparent;box-shadow:none;&:disabled,&[data-disabled='true']{background:transparent;}&:not(:disabled,[data-disabled='true']){&[aria-invalid='true'],&[data-invalid='true']{--underline-color:", ";--underline-height:2px;border-color:transparent;box-shadow:none;outline:none;}&:focus,&:focus-within,&[data-focused='true']{--underline-color:", ";--underline-height:2px;border-color:transparent;box-shadow:none;", ";}&:focus-visible,&[data-focusvisible='true']{", ";}&:hover:not( :focus-within,[data-focused='true'],[aria-invalid='true'],[data-invalid='true'] ){--underline-color:", ";border-color:transparent;box-shadow:none;}}}", ""], function (_ref) {
  var _theme$errors;
  var theme = _ref.theme;
  return (_theme$errors = theme.errors) !== null && _theme$errors !== undefined && _theme$errors.showInputBackground ? theme.colorPalette.accentColor.shade_light_4 : theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_light_4);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, typography.fontFamily, typography.fontSize, typography.lineHeight, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.light.shade_light_2;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.utilityColors.error;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "1px solid ".concat(theme.colorPalette.utilityColors.error);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, FocusOutline, FocusOutline, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, function (_ref12) {
  var _theme$errors2;
  var theme = _ref12.theme;
  return (_theme$errors2 = theme.errors) !== null && _theme$errors2 !== undefined && _theme$errors2.showInputBackground ? theme.colorPalette.accentColor.shade_light_4 : 'transparent';
}, function (_ref13) {
  var theme = _ref13.theme;
  return "1px solid ".concat(theme.colorPalette.utilityColors.error);
}, function (_ref14) {
  var theme = _ref14.theme;
  return "0 1px 0 0 ".concat(theme.colorPalette.utilityColors.error);
}, function (_ref15) {
  var theme = _ref15.theme;
  return "1px solid ".concat(theme.colorPalette.primaryColors.main.shade_default);
}, function (_ref16) {
  var theme = _ref16.theme;
  return "0 1px 0 0 ".concat(theme.colorPalette.primaryColors.main.shade_default);
}, FocusOutline, FocusOutline, function (_ref17) {
  var theme = _ref17.theme;
  return "solid 1px ".concat(theme.colorPalette.neutralColors.dark.shade_light_3);
}, function (_ref18) {
  var _theme$errors3;
  var theme = _ref18.theme;
  return (_theme$errors3 = theme.errors) !== null && _theme$errors3 !== undefined && _theme$errors3.showInputBackground ? theme.colorPalette.accentColor.shade_light_4 : 'transparent';
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colorPalette.utilityColors.error;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, FocusOutline, FocusOutline, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref23) {
  var inputWrapperStyle = _ref23.inputWrapperStyle;
  return inputWrapperStyle;
});
process.env.NODE_ENV !== "production" ? InputWrapper.displayName = 'InputWrapper' : undefined;
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-1v8eybg-1"
})(["background:transparent;border:none;cursor:", ";display:flex;flex-shrink:0;padding:", ";pointer-events:", ";position:absolute;right:0;user-select:none;", "[data-variant='basic_line'] &,", "[data-variant='basic_line_dashed'] &{padding-right:0;}", ";"], function (_ref24) {
  var isClickable = _ref24.isClickable;
  return isClickable ? 'pointer' : 'auto';
}, rem(12), function (_ref25) {
  var isClickable = _ref25.isClickable;
  return isClickable ? 'auto' : 'none';
}, InputWrapper, InputWrapper, function (_ref26) {
  var iconStyle = _ref26.iconStyle;
  return iconStyle;
});
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : undefined;
var ArrowDownIcon = /*#__PURE__*/styled(ButtonDownIcon).withConfig({
  displayName: "styledComponents__ArrowDownIcon",
  componentId: "sc-1v8eybg-2"
})(["color:", ";flex-shrink:0;min-height:", ";min-width:", ";height:", ";width:", ";transform:rotate(0deg);transition:transform 0.15s ease-in-out;", "[data-isopen='true'] &{transform:rotate(-180deg);transition:transform 0.15s ease-in-out;}", ":disabled &,", "[data-disabled=\"true\"] &{color:", ";}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, rem(24), rem(24), rem(24), rem(24), IconWrapper, InputWrapper, InputWrapper, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
});
process.env.NODE_ENV !== "production" ? ArrowDownIcon.displayName = 'ArrowDownIcon' : undefined;
var DashedUnderline = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__DashedUnderline",
  componentId: "sc-1v8eybg-3"
})(["background:", ";background-size:10px 100%;bottom:0;height:var(--underline-height,1px);position:absolute;width:100%;"], function (_ref29) {
  var theme = _ref29.theme;
  return "linear-gradient(\n      to right,\n      var(--underline-color, ".concat(theme.colorPalette.neutralColors.dark.shade_light_3, ") 50%,\n      transparent 50%)\n    ");
});
process.env.NODE_ENV !== "production" ? DashedUnderline.displayName = 'DashedUnderline' : undefined;
var Description = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Description",
  componentId: "sc-1v8eybg-4"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, typography.fontFamily, typography.fontWeightLight, typography.fontSizeSmall);
process.env.NODE_ENV !== "production" ? Description.displayName = 'Description' : undefined;
var AdornmentWrapper = /*#__PURE__*/styled(IconWrapper).withConfig({
  displayName: "styledComponents__AdornmentWrapper",
  componentId: "sc-1v8eybg-5"
})(["", "[data-adornmentposition='left'] &{left:0;}", "[data-variant='basic_line'][data-adornmentposition='left'] &,", "[data-variant='basic_line_dashed'][data-adornmentposition='left'] &{padding-left:0;}", "[data-variant='basic_line'][data-adornmentposition='right'] &,", "[data-variant='basic_line_dashed'][data-adornmentposition='right'] &{padding-right:0;}", ""], InputWrapper, InputWrapper, InputWrapper, InputWrapper, InputWrapper, function (_ref31) {
  var adornmentStyle = _ref31.adornmentStyle;
  return adornmentStyle;
});
process.env.NODE_ENV !== "production" ? AdornmentWrapper.displayName = 'AdornmentWrapper' : undefined;
var InputValue = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__InputValue",
  componentId: "sc-1v8eybg-6"
})(["background:transparent;border:none;box-sizing:border-box;color:", ";cursor:", ";display:inline-block;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";outline:none;overflow:hidden;padding:", ";text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;&:disabled,&[data-disabled='true']{color:", ";cursor:not-allowed;}", "[data-variant='basic_line'] &,", "[data-variant='basic_line_dashed'] &{padding-left:0;padding-right:0;}", "[data-hasicon='true']:not([data-adornmentposition='right']) &{padding-right:", ";}", "[data-variant='basic_line'][data-hasicon='true']:not([data-adornmentposition='right']) &,", "[data-variant='basic_line_dashed'][data-hasicon='true']:not([data-adornmentposition='right']) &{padding-right:", ";}", "[data-hasadornment='true'][data-adornmentposition='left'] &{padding-left:var(--mux-input-adornment-width,", ");}", "[data-variant='basic_line'][data-hasadornment='true'][data-adornmentposition='left'] &,", "[data-variant='basic_line_dashed'][data-hasadornment='true'][data-adornmentposition='left'] &{padding-left:var(--mux-input-adornment-width,", ");}", "[data-hasadornment='true'][data-adornmentposition='right'] &{padding-right:var(--mux-input-adornment-width,", ");}", "[data-variant='basic_line'][data-hasadornment='true'][data-adornmentposition='right'] &,", "[data-variant='basic_line_dashed'][data-hasadornment='true'][data-adornmentposition='right'] &{padding-right:var(--mux-input-adornment-width,", ");}", ""], function (_ref32) {
  var theme = _ref32.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref33) {
  var cursor = _ref33.cursor;
  return cursor;
}, typography.fontFamily, typography.fontSize, typography.fontWeightNormal, typography.lineHeight, rem(12), function (_ref34) {
  var theme = _ref34.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, InputWrapper, InputWrapper, InputWrapper, rem(48), InputWrapper, InputWrapper, rem(36), InputWrapper, rem(36), InputWrapper, InputWrapper, rem(24), InputWrapper, rem(36), InputWrapper, InputWrapper, rem(24), function (_ref35) {
  var inputStyle = _ref35.inputStyle;
  return inputStyle;
});
process.env.NODE_ENV !== "production" ? InputValue.displayName = 'InputValue' : undefined;
var Label = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Label",
  componentId: "sc-1v8eybg-7"
})(["overflow:hidden;text-overflow:ellipsis;"]);
process.env.NODE_ENV !== "production" ? Label.displayName = 'Label' : undefined;
var List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__List",
  componentId: "sc-1v8eybg-8"
})(["background:", ";display:flex;flex-direction:column;gap:1px;margin:0;max-height:inherit;overflow-x:hidden;overflow-y:auto;outline:none;padding:1px;text-overflow:ellipsis;width:", ";", ""], function (_ref36) {
  var theme = _ref36.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, function (_ref37) {
  var minWidth = _ref37.minWidth;
  return rem(minWidth);
}, function (_ref38) {
  var menuStyle = _ref38.menuStyle;
  return menuStyle;
});
process.env.NODE_ENV !== "production" ? List.displayName = 'List' : undefined;
var ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__ListItem",
  componentId: "sc-1v8eybg-9"
})(["--listitem-font-weight:", ";--listitem-hover-bg:", ";--listitem-selected-bg:", ";--listitem-selected-font-weight:", ";--listitem-selected-hover:", ";--listitem-selected-show-left-border:", ";display:flex;flex-shrink:0;align-items:flex-start;justify-content:space-between;background:", ";border:transparent;box-sizing:border-box;color:", ";font-family:", ";font-size:", ";font-weight:var(--listitem-font-weight);line-height:", ";outline:none;overflow:hidden;padding:", ";text-align:left;text-overflow:ellipsis;white-space:nowrap;&[aria-disabled='true']{color:", ";cursor:not-allowed;}&[aria-selected='true']:not([aria-disabled='true']){background:var(--listitem-selected-bg);box-shadow:", ";font-weight:var(--listitem-selected-font-weight);}&[data-focused='true']{box-shadow:", ";&[aria-selected='true']:not([aria-disabled='true']){box-shadow:", ";}}&[data-focused='true']:not([aria-disabled='true']),&:hover:not([aria-disabled='true']){cursor:pointer;&[aria-selected='true']{background:var(--listitem-selected-hover);}&:not([aria-selected='true']){background:var(--listitem-hover-bg);}}"], function (_ref39) {
  var theme = _ref39.theme;
  return theme.select.listItem.fontWeight;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.select.listItem.hover.bg;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.select.listItem.selected.bg;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.select.listItem.selected.fontWeight;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.select.listItem.selected.hover;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.select.listItem.selected.showLeftBorder;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, typography.fontFamily, typography.fontSize, typography.lineHeight, rem(12), function (_ref47) {
  var theme = _ref47.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_1;
}, function (_ref48) {
  var _theme$select;
  var theme = _ref48.theme;
  return (_theme$select = theme.select) !== null && _theme$select !== undefined && (_theme$select = _theme$select.listItem) !== null && _theme$select !== undefined && (_theme$select = _theme$select.selected) !== null && _theme$select !== undefined && _theme$select.showLeftBorder ? "0px 0px 0px 0.5px ".concat(theme.colorPalette.neutralColors.dark.shade_light_4, ", inset 4px 0px 0px 0px ").concat(theme.colorPalette.primaryColors.main.shade_default) : "0px 0px 0px 0.5px ".concat(theme.colorPalette.neutralColors.dark.shade_light_4);
}, function (_ref49) {
  var theme = _ref49.theme;
  return "inset 0 0 0 2px ".concat(theme.colorPalette.neutralColors.dark.shade_light_2);
}, function (_ref50) {
  var _theme$select2;
  var theme = _ref50.theme;
  return (_theme$select2 = theme.select) !== null && _theme$select2 !== undefined && (_theme$select2 = _theme$select2.listItem) !== null && _theme$select2 !== undefined && (_theme$select2 = _theme$select2.selected) !== null && _theme$select2 !== undefined && _theme$select2.showLeftBorder ? "inset 0 0 0 2px ".concat(theme.colorPalette.neutralColors.dark.shade_light_2, ",\n              inset 4px 0px 0px 0px ").concat(theme.colorPalette.primaryColors.main.shade_default) : "inset 0 0 0 2px ".concat(theme.colorPalette.neutralColors.dark.shade_light_2);
});
process.env.NODE_ENV !== "production" ? ListItem.displayName = 'ListItem' : undefined;
var PopoverWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__PopoverWrapper",
  componentId: "sc-1v8eybg-10"
})(["box-shadow:0 4px 6px -1px rgb(0 0 0 / 0.1),0 2px 4px -2px rgb(0 0 0 / 0.1);background:white;margin-bottom:4px;margin-top:4px;position:absolute;"]);
process.env.NODE_ENV !== "production" ? PopoverWrapper.displayName = 'PopoverWrapper' : undefined;
var Placeholder = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__Placeholder",
  componentId: "sc-1v8eybg-11"
})(["color:", ";display:inline-block;", ":disabled &,", "[data-disabled='true'] &{color:", ";}"], function (_ref51) {
  var theme = _ref51.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, InputValue, InputValue, function (_ref52) {
  var theme = _ref52.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
});
process.env.NODE_ENV !== "production" ? Placeholder.displayName = 'Placeholder' : undefined;
var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1v8eybg-12"
})(["box-sizing:border-box;display:inline-flex;flex-direction:column;min-width:", ";width:", ";", ""], function (_ref53) {
  var minWidth = _ref53.minWidth;
  return "var(--mux-input-min-width, ".concat(minWidth || 0, ")");
}, function (_ref54) {
  var width = _ref54.width;
  return "var(--mux-input-width, ".concat(width || rem(DEFAULT_INPUT_WIDTH), ")");
}, function (_ref55) {
  var rootStyle = _ref55.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : undefined;

export { AdornmentWrapper, ArrowDownIcon, DashedUnderline, Description, IconWrapper, InputValue, InputWrapper, Label, List, ListItem, Placeholder, PopoverWrapper, Root };
